
/**Why we need this function? We need this function to generate a unique filename
 * for the user based on how they have filtered the data. Converted the object to array 
 * otherwise we would have to check the property everytime.
 */
export const filterBasedFileNameGenerator = (filterObject) =>{
    let fileName = '';
    let combinedItems = Object.values(filterObject)
    combinedItems.forEach((combinedItem)=>{
        if(combinedItem !== ''){
            fileName += combinedItem + '_';
        }
    })

    if (fileName === '') fileName = "All Prices"

    return fileName
}